import React, { useEffect, useState } from 'react';
import { researchosService } from '../../services/researchosService';

// Quorum read-only "Coverage": the channels we currently track (pure DB truth from
// ChannelsView) — name, stored transcript count, date span. No relevance editing, no
// gap-check enumeration, no backfill trigger (those stay in the admin CoveragePanel);
// requesting a NEW channel happens in the Backfill & Runs tab's request form. The
// official-channel declaration is a superuser action and lives in the admin CoveragePanel.
export default function TrackedChannelsPanel() {
  const [channels, setChannels] = useState(null);

  useEffect(() => {
    researchosService.getChannels()
      .then((r) => setChannels(r.data || []))
      .catch(() => setChannels([]));
  }, []);

  if (channels === null) return <div className="text-sm text-gray-500">Loading…</div>;
  return (
    <div className="rounded-lg border border-gray-200 dark:border-gray-800">
      <div className="border-b border-gray-100 px-3 py-2 text-[11px] uppercase tracking-wider text-gray-500 dark:border-gray-800/60">
        Tracked channels ({channels.length}) — want one added? Submit it in Backfill &amp; Runs.
      </div>
      {channels.length === 0 ? (
        <p className="px-3 py-3 text-sm text-gray-500 dark:text-gray-400">No channels tracked yet.</p>
      ) : channels.map((c, i) => (
        <div key={c.channel_id || c.source_ref || i}
          className="flex flex-wrap items-center gap-x-4 gap-y-1 border-b border-gray-100 px-3 py-2 text-sm last:border-b-0 dark:border-gray-800/60">
          <span className="font-medium text-gray-900 dark:text-gray-100">{c.source_ref}</span>
          <span className="tabular-nums text-gray-600 dark:text-gray-300">{c.stored} videos</span>
          <span className="ml-auto text-xs tabular-nums text-gray-400">
            {c.earliest ? String(c.earliest).slice(0, 10) : '—'} → {c.latest ? String(c.latest).slice(0, 10) : '—'}
          </span>
        </div>
      ))}
    </div>
  );
}
